import { motion } from 'motion/react';
import { usePathname } from 'next/navigation';
import React from 'react';

import { cn } from '@/lib/utils/cn';

import useOutsideClick from '@/hooks/useOutsideClick';

import Link from '@/components/ui/link';

export default function NavigationMenu({ closeNavigationMenu }) {
  const pathname = usePathname();
  const DURATION = 0.4;

  const ref = useOutsideClick(closeNavigationMenu);

  return (
    <>
      <div className="fixed inset-0 z-40 bg-secondary/40 transition-all duration-300 ease-in-out"></div>
      <div
        ref={ref}
        className="fixed top-4 right-[5%] z-50 flex max-h-[calc(100vh-80px)] w-full max-w-[90%] flex-col gap-8 overflow-y-auto rounded-lg bg-primary px-5 pt-20 pb-8 text-white transition-all duration-300 ease-in-out sm:max-w-[70%] md:max-w-[50%]"
      >
        <button
          onClick={closeNavigationMenu}
          className="absolute top-4 right-4 text-lg uppercase md:text-xl"
        >
          Close
        </button>
        <div className="grid grid-rows-4 gap-y-6 rounded-lg font-nohemi">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: DURATION, delay: 0 }}
            className="text-5xl text-white uppercase"
          >
            <Link
              prefetch={true}
              href="/"
              className={cn(
                pathname === '/'
                  ? 'opacity-100'
                  : 'opacity-70 transition-all duration-300 ease-in-out hover:opacity-100',
              )}
              onClick={closeNavigationMenu}
            >
              Home
            </Link>
          </motion.div>
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: DURATION, delay: 0.1 }}
            className="text-5xl text-white uppercase"
          >
            <Link
              prefetch={true}
              onClick={closeNavigationMenu}
              href="/about"
              className={cn(
                pathname === '/about'
                  ? 'opacity-100'
                  : 'opacity-70 transition-all duration-300 ease-in-out hover:opacity-100',
              )}
            >
              About
            </Link>
          </motion.div>
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: DURATION, delay: 0.2 }}
            className="text-5xl text-white uppercase"
          >
            <Link
              onClick={closeNavigationMenu}
              prefetch={true}
              href="/projects"
              className={cn(
                pathname === '/projects'
                  ? 'opacity-100'
                  : 'opacity-70 transition-all duration-300 ease-in-out hover:opacity-100',
              )}
            >
              Projects
            </Link>
          </motion.div>
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: DURATION, delay: 0.2 }}
            className="text-5xl text-white uppercase"
          >
            <Link
              onClick={closeNavigationMenu}
              prefetch={true}
              href="/blogs"
              className={cn(
                pathname === '/blogs'
                  ? 'opacity-100'
                  : 'opacity-70 transition-all duration-300 ease-in-out hover:opacity-100',
              )}
            >
              Blogs
            </Link>
          </motion.div>
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: DURATION, delay: 0.3 }}
            className="text-5xl text-white uppercase"
          >
            <Link
              onClick={closeNavigationMenu}
              prefetch={true}
              href="/resume"
              className={cn(
                pathname === '/resume'
                  ? 'opacity-100'
                  : 'opacity-70 transition-all duration-300 ease-in-out hover:opacity-100',
              )}
            >
              Resume
            </Link>
          </motion.div>
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: DURATION, delay: 0.4 }}
            className="text-5xl text-white uppercase"
          >
            <Link
              prefetch={true}
              onClick={closeNavigationMenu}
              href="/contact"
              className={cn(
                pathname === '/contact'
                  ? 'opacity-100'
                  : 'opacity-70 transition-all duration-300 ease-in-out hover:opacity-100',
              )}
            >
              Contact
            </Link>
          </motion.div>
        </div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: DURATION, delay: 0.5 }}
          className="grid grid-cols-1 justify-between gap-x-2 text-base lowercase md:grid-cols-2"
        >
          <Link href="mailto:hello@piyushgambhir.com">
            hello@piyushgambhir.com
          </Link>
        </motion.div>
      </div>
    </>
  );
}
